export default function SectionHeading({ eyebrow, title, text, center = false, testId }) {
  return (
    <div className={`section-heading ${center ? "center" : ""}`} data-testid={testId}>
      {eyebrow && <span className="eyebrow" data-testid={`${testId}-eyebrow`}>{eyebrow}</span>}
      <h2 data-testid={`${testId}-title`}>{title}</h2>
      {text && <p data-testid={`${testId}-text`}>{text}</p>}
    </div>
  );
}